import { IQApp } from "capacitor-garmin-sdk";

// Minimum version of Garmin Connect app required for Bluetooth syncing
export const GARMIN_BT_MIN_VERSION = 0; // Not really needed for scorza

// Garmin full app
export const GARMIN_FULL_APP_INFO: IQApp = {
    uuid: "cbd9a3bd-58c9-4add-9a2e-00ab4ee2a4e8", // Scorza Garmin app
    storeUUID: "fcabde94-66ff-442c-bbc1-de04d0d0837f",
};

// Watches that could only run the legacy REFSIX Lite app. Scorza has no
// lite app, so these devices are unsupported — must not include any device
// compatible with the full Scorza Garmin app
export const GARMIN_UNSUPPORTED_DEVICES = [
    "ForeAthlete 645",
    "ForeAthlete 935",
    "Forerunner 645",
    "Forerunner 935",
    "fēnix 5",
    "quatix 5",
    "fēnix 5S",
    "fēnix Chronos",
    "vívoactive 3",
];

export const GARMIN_INCOMPATIBLE_DEVICES = [
    "edge", // cycle computers
    "etrex", // handheld GPS
    "gpsmap", // handheld GPS
    "montana", // handheld GPS
    "oregon", // handheld GPS
    "rino", // handheld GPS
    "index", // scales
];

export const PLAY_STORE_CONNECT_URL =
    "https://play.google.com/store/apps/details?id=com.garmin.android.apps.connectmobile";
export const APP_STORE_CONNECT_URL =
    "https://apps.apple.com/app/garmin-connect/id583446403";

export const PLAY_STORE_CONNECT_IQ_URL =
    "https://play.google.com/store/apps/details?id=com.garmin.connectiq";
export const APP_STORE_CONNECT_IQ_URL =
    "https://apps.apple.com/app/garmin-connect-iq/id583722529";
